import { render } from "./UpdateCompanyContactPersonDialog.vue?vue&type=template&id=d3930d42&scoped=true"
import script from "./UpdateCompanyContactPersonDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCompanyContactPersonDialog.vue?vue&type=script&lang=js"

import "./UpdateCompanyContactPersonDialog.vue?vue&type=style&index=0&id=d3930d42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3930d42"]])

export default __exports__